class NumberFormatter {
  static format(value) {
    return Intl.NumberFormat().format(value);
  }
}

export default NumberFormatter;
